import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const usePendingAnnotations = () => {
  const {
    pendingAnnotationAtom
  } = useSidePanel();
  const pendingAnnotations = useAtomValue(pendingAnnotationAtom);
  return pendingAnnotations;
};